import { client } from '@/shared/api';
import { USER_ROLE_QUERY_ID } from '@/entities/user';
const PATH_AUTH_API = 'Admin';
export const getUsers = async ({ pageSize, pageNumber, guid, fullName, loginName, role }) => {
    const { data } = await client.get(`${PATH_AUTH_API}/GetUsers`, {
        // Передаём params объектом: axios опускает undefined и кодирует значения (нужно для кириллицы).
        params: {
            pageSize,
            pageNumber,
            'user-guid-query': guid,
            'user-full-name-query': fullName,
            'user-login-name-query': loginName,
            'user-role-query': role ? USER_ROLE_QUERY_ID[role] : undefined,
        },
    });
    if (!data.isSuccess) {
        throw new Error(`GetUsers. ExceptionString: ${data.errorMessage}`);
    }
    return data;
};
export const updateUser = async ({ guid, ...body }) => {
    const { data } = await client.patch(`${PATH_AUTH_API}/User/${guid}`, body, {
        headers: { 'Content-Type': 'application/json-patch+json' },
    });
    if (!data.isSuccess) {
        throw new Error(`UpdateUser. ExceptionString: ${data.errorMessage}`);
    }
    return data;
};
export const createUser = async (config) => {
    const { data } = await client.post(`${PATH_AUTH_API}/User`, config, {
        headers: { 'Content-Type': 'application/json-patch+json' },
    });
    if (!data.isSuccess) {
        throw new Error(`CreateUser. ExceptionString: ${data.errorMessage}`);
    }
    return data;
};
export const deleteUser = async (guid) => {
    const { data } = await client.delete(`${PATH_AUTH_API}/User/${guid}`);
    if (!data.isSuccess) {
        throw new Error(`DeleteUser. ExceptionString: ${data.errorMessage}`);
    }
    return data;
};
